/*
 Helper module with URI parsing/creating methods for map location data
 */
import * as L from "leaflet";

//save current map position to the browser state
export function updateBrowserUrl(mapContext) {
    let l = locationFromMapState(mapContext.map)
    history.pushState(l, `MapHub at ${l.lat},${l.lng}`, '/?' + [locationUri(l), optionsToUrlOptions(mapContext.mode)].join('&'));
}

export function locationLoadFromBrowserUrl() {
    let u = new URL(window.location);
    let z = u.searchParams.get("z");
    if (z == null)
        return null;
    try {
        return {location: new L.latLng(u.searchParams.get("ll").split(",")), zoom: z}
    } catch (e) {
        return null
    }
}

export function optionsFromBrowserUrl(options) {
    let map = {
        "move": "em",
        "zoom": "ez",
        "observer": "eo"
    }

    if (! options)
        options = {}
    try {
        let p = new URL(window.location).searchParams;
        for (let o in map) {
            let v = p.get(map[o])
            if (v) {
                options[o] = (v === "1")
            }
        }
    } catch (e) {

    }
    return options
}

export function optionsToUrlOptions(options) {
    // todo it's better to rewrite this as a object storing default state
    // initiated from mapContext
    let defaults = {
        "move": true,
        "zoom": true,
        "observer": false,
    }

    let map = {
        "move": "em",
        "zoom": "ez",
        "observer": "eo"
    }

    let uriOptions = []
    for (let o in map) {
        if (options[o] !== undefined && options[o] !== defaults[o]) {
            uriOptions.push(map[o] + '=' + (options[o] ? 1 : 0))
        }
    }
    return uriOptions.join('&')
}

export function locationUri(l) {
    return `ll=${l.lat}%2C${l.lng}&z=${l.zoom}`
}

export function locationFromMapState(map) {
    let loc = (map) ? map.getCenter() : new L.latLng(0, 0);
    return {
        lat: loc.lat.toFixed(5),
        lng: loc.lng.toFixed(5),
        zoom: (map) ? map.getZoom() : 10}
}

